import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { MarketplaceResource } from "@exonn/js-sdk";

export const module: Module<MarketplaceResource> = {
  id: ResourceEnum.Marketplace,
  bigIcon: <span className={"icon-20-marketplaces"} />,
  smallIcon: <span className={"icon-15-marketplaces"} />,
  name: (t: TFunction) => t("moduleName.marketplace"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
